<template>
  <modal name="opening-session-suspension-for-correction-modal"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Բացման նիստի կասեցում շտկման նպատակով</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('opening-session-suspension-for-correction-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <table id="datatable" class="table table-bordered dt-responsive nowrap" style="border-collapse: collapse; border-spacing: 0; width: 100%;">
        <thead>
        <tr>
          <th></th>
          <th>Մասնակցի անվանում</th>
          <th>Հիմնավորում</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <input type="checkbox">
          </td>
          <td>«ԷՅՉ ԷՍ ՓԱՐԹՆԵՐՍ» ՍՊԸ</td>
          <td>
            <input type="text" class="" style="margin: 0 auto; width: 100%;">
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button @click="$modal.hide('opening-session-suspension-for-correction-modal')" type="button" class="btn btn-sm btn-primary">
        Պահպանել
      </button>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'OpeningSessionSuspensionForCorrectionModal',
  }
</script>

<style scoped>

</style>
